<div class="workspace no-back-btn no-bottom-bar">
  <div class="row" id="campaign_new">
    <div class="col-md-12">
      <div class="campaign-container campaign-tab-header d-flex flex-column justify-content-center">
        <div class="head d-flex flex-row justify-content-center">
          <div class="spacer flex-fill"></div>
          <div class="head-menu">
            <hr class="bottom-line" />
            <div class="items">
              <span [ngClass]="{'selected': isSelectedPermissionTab()}"
                    (click)="onSelectContactPermissionTab()">
                {{'contact_permission.tab_permission' | translate}}
              </span>
              <span *ngIf="isActivatedAdvertiserChat() && contactPermission"
                    [ngClass]="{'selected': isSelectedContactTab()}"
                    (click)="onSelectContactTab()">
                {{'contact_permission.tab_contact' | translate}}
              </span>
            </div>
          </div>
          <div class="spacer flex-fill"></div>
        </div>
      </div>
      <div class="row d-flex flex-row justify-content-center campaign-details-container">
        <div class="col-md-8 contact-perm-container" *ngIf="isSelectedPermissionTab()">
          <contact-permission-detail [contactPermission]="contactPermission"
                                     [permissionToken]="permissionToken"
                                     [isDeletedOrError]="isDeletedOrError"
                                     (openContactEvt)="onSelectContactTab()"
                                     (declineCallback)="onDeclineContactPermissionRequest($event)"
                                     (acceptCallback)="onAcceptContactPermissionRequest($event)">
          </contact-permission-detail>
        </div>
        <div class="col-md-8" *ngIf="isSelectedContactTab() && conversation">
          <div class="chat-container">
            <influencer-chat [conversation]="conversation" [showActivityLog]="showActivityLog"></influencer-chat>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<achoo-popup #WarningFailToRetrieveContactPermission [isSpecialPopup]="true">
    <fail-retrieve-campaign-modal *ngIf="errorType"
                                  [errorType]="errorType"
                                  [showTryAgainButton]="isShowRetryButton(errorType)"
                                  (tryAgain)="tryAgainHandler(errorType)">
    </fail-retrieve-campaign-modal>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/influencer-platform/contact-permission/contact-permission.component.html